import { Box, TableCell, TableRow, Tooltip, Typography } from "@mui/material";
import CheckBoxTableRow from "./CheckBoxTableRow";
import { ConfigurationType, NotificationConfiguration } from "../types";
import { useState, useEffect } from "react";

type SendByMethods =
  | "reportMonthlyConfiguration"
  | "reportDailyConfiguration"
  | "reportPartialConfiguration"
  | "alarmsBlandConfiguration"
  | "alarmsMediumConfiguration"
  | "alarmsSevereConfiguration";

export default function UserNotificationConfigurationToggle(props: {
  configurationType: ConfigurationType;
  configurationName: SendByMethods;
  configuration: NotificationConfiguration;
  setConfiguration: React.Dispatch<
    React.SetStateAction<NotificationConfiguration | undefined>
  >;
  title: string;
  disabled: boolean;
}) {
  const {
    configurationType,
    title,
    disabled,
    setConfiguration,
    configuration,
    configurationName,
  } = props;
  const [emailSwitch, setEmailSwitch] = useState<boolean>(
    configurationType.sendByMethods.includes("email")
  );
  const [pushSwitch, setPushSwitch] = useState<boolean>(
    configurationType.sendByMethods.includes("push")
  );

  function getSendByMethods() {
    const methods: string[] = [];
    emailSwitch && methods.push("email");
    pushSwitch && methods.push("push");
    return methods;
  }

  function updateConfiguration() {
    setConfiguration({
      ...configuration,
      [configurationName]: {
        name: configurationType.name,
        enabled: getSendByMethods().length > 0 ? true : false,
        sendByMethods: getSendByMethods(),
      },
    });
  }

  useEffect(() => {
    updateConfiguration();
  }, [emailSwitch, pushSwitch]);

  return (
    <Tooltip title={disabled ? "Notificações desabilitadas" : ""}>
      <TableRow>
        <TableRow sx={{ display: "flex", width: "100%" }}>
          <TableCell
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            align="left"
          >
            <Typography
              sx={{
                color: disabled ? "rgba(217, 217, 217, 0.5)" : "#FFF",
              }}
            >
              {title}
            </Typography>
            <Box
              sx={{ display: "flex", flexDirection: "row", columnGap: "32px" }}
            >
              <CheckBoxTableRow
                name="Email"
                disabled={disabled}
                active={emailSwitch}
                onChange={(_, checked) => {
                  setEmailSwitch(checked);
                }}
              />
              <CheckBoxTableRow
                name="Push"
                disabled={disabled}
                active={pushSwitch}
                onChange={(_, checked) => {
                  setPushSwitch(checked);
                }}
              />
            </Box>
          </TableCell>
        </TableRow>
      </TableRow>
    </Tooltip>
  );
}
